import { render, staticRenderFns } from "./ModalTeamForm.vue?vue&type=template&id=573ea01f"
import script from "./ModalTeamForm.vue?vue&type=script&lang=js"
export * from "./ModalTeamForm.vue?vue&type=script&lang=js"
import style0 from "./ModalTeamForm.vue?vue&type=style&index=0&id=573ea01f&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('573ea01f')) {
      api.createRecord('573ea01f', component.options)
    } else {
      api.reload('573ea01f', component.options)
    }
    module.hot.accept("./ModalTeamForm.vue?vue&type=template&id=573ea01f", function () {
      api.rerender('573ea01f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/team/components/ModalTeamForm.vue"
export default component.exports